import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { CameraScannerService } from '@core/camera-scanner/camera-scanner.service';
import { UserService } from '@core/user/user.service';
import { IonModal } from '@ionic/angular';
import pkg from '@root/package.json';
@Component({
  selector: 'app-header-simples',
  templateUrl: './header-simples.component.html',
  styleUrls: ['./header-simples.component.scss'],
})
export class HeaderSimplesComponent {

  @Input() apptitle: string;

  router = inject(Router);

  userService = inject(UserService);
  user$ = this.userService.user$;

  auth = inject(AuthService);
  version = pkg.version;

  cameraScannerService = inject(CameraScannerService);
  cameraScanEnabled$ = this.cameraScannerService.enabled$;

  @ViewChild('IonUserModal') ionUserModal: IonModal;

  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  handelUserModal() {
    this.ionUserModal.present();
  }

  async canDismiss(data?: any, role?: string) {
    return role !== 'gesture';
  }

  onToggleCameraScan(event: CustomEvent): void {
    this.cameraScannerService.setEnabled((event as any).detail.checked);
  }

  logout() {
    this.auth.signOut().subscribe(() => {
      this.router.navigate(['/sign-in']);
    });
  }
}
